<template>
<popup-base class="password-change-popup" @close="closePopup">
  <template v-if="!successPasswordConfirmation">
    <div slot="header" class="password-change-popup__title">
      Password change
    </div>
    <div slot="body" class="password-change-popup__wrap">
      <div class="password-change-popup__notice">
        Input your old and new passwords in&nbsp;the fields below.
      </div>
      <form novalidate @submit.stop.prevent="tryToSendPasswordChangeForm">
        <input-el
          class="password-change__password popup-input"
          type="password"
          name="password"
          inputId="password"
          placeholder="Enter your old password"
          label="Old password"
          @input="serverFieldErrors.currentPassword = null"
          v-model="$v.formData.currentPassword.$model"
          :error="$v.formData.currentPassword.$error"
        />
        <input-el
          class="password-change__password popup-input"
          type="password"
          name="newPassword"
          inputId="newPassword"
          placeholder="Enter your new password"
          label="New password"
          @input="serverFieldErrors.newPassword = null"
          v-model="$v.formData.newPassword.$model"
          :error="$v.formData.newPassword.$error"
        />
        <input-el
          class="password-change__password-last popup-input"
          type="password"
          name="repeatPassword"
          inputId="repeatPassword"
          placeholder="Repeat your new password"
          label="Repeat password"
          @input="serverFieldErrors.confirmNewPassword = null"
          v-model="$v.formData.confirmNewPassword.$model"
          :error="$v.formData.confirmNewPassword.$error"
        />
        <button-el class="next-btn" red large left :disabled="requestInProgress">Continue
          <icon-base red>
            <icon-arrow-min />
          </icon-base>
        </button-el>
        <round-btn small @click="closePopup" class="round-close-btn">
          <icon-base red>
            <icon-cross />
          </icon-base>
        </round-btn>
      </form>
    </div>
  </template>
  <template v-else>
    <div slot="header" class="password-change-popup__title">
      Success!
    </div>
    <div slot="body" class="password-change-popup__wrap">
      <div class="password-change-popup__notice password-change-popup__notice_confirmation">
        You successfully changed your password!
      </div>
      <button-el red large left @click.native="closePopup">Close
        <icon-base red>
          <icon-check />
        </icon-base>
      </button-el>
    </div>
  </template>
</popup-base>
</template>

<script>
import validateFormMixin from 'src/mixins/validateForm';
import { required, sameAs } from 'vuelidate/lib/validators';
import { IconCheck, IconArrowMin, IconCross } from 'Icons';
import PopupBase from 'Common/PopupBase';

export default {
  mixins: [
    validateFormMixin,
  ],
  data: () => ({
    requestInProgress: false,
    successPasswordConfirmation: false,
    formData: {
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    },
    serverFieldErrors: {
      currentPassword: {},
      newPassword: {},
      confirmNewPassword: {},
    },
  }),
  validations: {
    formData: {
      currentPassword: {
        required,
        serverError() {
          return !(this.serverFieldErrors && this.serverFieldErrors.currentPassword);
        },
      },
      newPassword: {
        required,
        serverError() {
          return !(this.serverFieldErrors && this.serverFieldErrors.newPassword);
        },
      },
      confirmNewPassword: {
        required,
        sameAs: sameAs('newPassword'),
        serverError() {
          return !(this.serverFieldErrors && this.serverFieldErrors.confirmNewPassword);
        },
      },
    },
  },
  components: {
    IconCheck,
    IconCross,
    IconArrowMin,
    PopupBase,
  },
  methods: {
    closePopup() {
      this.$emit('closePopup');
    },
    tryToSendPasswordChangeForm() {
      this.validateForm(null, this.sendForm);
    },
    sendForm() {
      this.requestInProgress = true;
      this.$apiService.changePassword(this.formData).then(() => {
        this.successPasswordConfirmation = true;
      }).catch((errors) => {
        if (errors.fieldErrors) {
          this.serverFieldErrors = errors.fieldErrors;
        }
      }).finally(() => {
        this.requestInProgress = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  $max-width: 430px;
  .password-change-popup {
    &__wrap {
      width: 100%;
      max-width: $max-width;
      padding: 37px 30px 30px;
    }
    &__notice {
      @include font(13px, $black-color1);
      margin-bottom: 24px;
      line-height: 22px;
      &_confirmation {
        margin-bottom: 30px;
        line-height: 21px;
      }
    }
  }
  .password-change {
    &__password {
      margin-bottom: 30px;
    }
    &__password-last {
      margin-bottom: 60px;
    }
  }
  .round-close-btn {
    display: none;
  }
  @include mobileStyles {
    .round-close-btn {
      display: inline-flex;
      margin-left: 30px;
      vertical-align: middle;
    }
  }
  $bp: $max-width + ($popup-side-margin * 2);
  @media screen and (max-width: $bp) {
    .next-btn {
      margin-left: $popup-side-margin;
    }
    .password-change-popup {
      &__notice {
        padding-left: $popup-side-margin;
        padding-right: $popup-side-margin;
      }
      &__wrap {
        padding-left: $popup-side-margin;
        padding-right: $popup-side-margin;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/settings/PasswordChangePopup.vue